import { HeartHandshake, Monitor, Moon, Search, ShieldCheck, Sun } from "lucide-react";
import { type MouseEvent, useEffect, useState } from "react";
import { AdminApp } from "./components/AdminApp";
import { PublicLookup } from "./components/PublicLookup";

export function App() {
  const [path, setPath] = useState(window.location.pathname);
  const [theme, setTheme] = useState<"system" | "light" | "dark">(() => {
    const stored = localStorage.getItem("themeMode");
    return stored === "light" || stored === "dark" || stored === "system" ? stored : "system";
  });
  const isAdmin = path.startsWith("/admin");

  useEffect(() => {
    const handlePopState = () => setPath(window.location.pathname);
    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, []);

  useEffect(() => {
    localStorage.setItem("themeMode", theme);
    document.documentElement.dataset.theme = theme;
  }, [theme]);

  function navigate(event: MouseEvent<HTMLAnchorElement>, nextPath: string) {
    event.preventDefault();
    if (window.location.pathname !== nextPath) {
      window.history.pushState(null, "", nextPath);
    }
    setPath(nextPath);
  }

  return (
    <div className="app-shell">
      <header className="topbar">
        <div className="topbar-title">
          <a className="brand" href="/" onClick={(event) => navigate(event, "/")}>
            <span className="brand-mark" aria-hidden="true">
              <HeartHandshake size={24} />
            </span>
            <span>
              <strong>สิทธิประโยชน์ผู้บริจาค</strong>
              <small>โรงพยาบาลชลบุรี</small>
            </span>
          </a>
          <div className="theme-selector" aria-label="ธีม">
            <button
              className={theme === "system" ? "active" : ""}
              type="button"
              onClick={() => setTheme("system")}
              title="ตามเครื่อง"
              aria-label="ตามเครื่อง"
            >
              <Monitor size={16} />
            </button>
            <button
              className={theme === "light" ? "active" : ""}
              type="button"
              onClick={() => setTheme("light")}
              title="สว่าง"
              aria-label="สว่าง"
            >
              <Sun size={16} />
            </button>
            <button
              className={theme === "dark" ? "active" : ""}
              type="button"
              onClick={() => setTheme("dark")}
              title="มืด"
              aria-label="มืด"
            >
              <Moon size={16} />
            </button>
          </div>
        </div>
        <nav className="topnav" aria-label="ส่วนหลัก">
          <a className={!isAdmin ? "active" : ""} href="/" onClick={(event) => navigate(event, "/")}>
            <Search size={16} />
            ตรวจสิทธิ
          </a>
          <a className={isAdmin ? "active" : ""} href="/admin" onClick={(event) => navigate(event, "/admin")}>
            <ShieldCheck size={16} />
            ผู้ดูแล
          </a>
        </nav>
      </header>

      <main>{isAdmin ? <AdminApp /> : <PublicLookup />}</main>
    </div>
  );
}
